/* rt: escada de descontos do cart drawer (snippets/rt-cart-volume-ladder.liquid).
   O AJAX do tema só troca [data-api-line-items] e [data-api-cart-price]; o topo do drawer
   fica como veio do servidor, por isso a barra recalcula-se aqui a cada mudança do carrinho. */
(function () {
  if (window.rtVolumeLadder) return;
  window.rtVolumeLadder = true;

  const parseTiers = (raw) =>
    (raw || '')
      .split(',')
      .map((pair) => pair.split(':'))
      .filter((p) => p.length === 2)
      .map((p) => ({ qty: parseInt(p[0], 10), pct: parseInt(p[1], 10) }))
      .filter((t) => t.qty > 0 && t.pct > 0);

  function render(root, count) {
    const tiers = parseTiers(root.dataset.tiers);
    if (!tiers.length) return;

    root.dataset.count = count;
    root.classList.toggle('is-empty', count === 0);

    const next = tiers.find((t) => count < t.qty);
    const top = tiers.filter((t) => count >= t.qty).pop();
    const msg = root.querySelector('[data-rt-vl-msg]');
    if (msg) {
      if (next) {
        const remain = next.qty - count;
        msg.innerHTML = (root.dataset.message || '')
          .replaceAll('[n]', remain)
          .replaceAll('[s]', remain > 1 ? 's' : '')
          .replaceAll('[pct]', next.pct);
      } else {
        msg.innerHTML = (root.dataset.messageDone || '').replaceAll('[pct]', top ? top.pct : '');
      }
    }

    const segs = root.querySelectorAll('[data-rt-vl-seg]');
    let prev = 0;
    tiers.forEach((tier, i) => {
      const seg = segs[i];
      if (!seg) return;
      const span = tier.qty - prev;
      const filled = Math.min(Math.max(count - prev, 0), span);
      const fill = seg.querySelector('[data-rt-vl-fill]');
      if (fill) fill.style.width = span > 0 ? (filled * 100) / span + '%' : '0%';
      seg.classList.toggle('is-done', count >= tier.qty);
      prev = tier.qty;
    });
  }

  function update(event) {
    const root = document.querySelector('[data-rt-volume-ladder]');
    if (!root) return;

    // a proteção de envio (Theme settings → rt_protection_product) não conta para a escada
    const ex = parseInt(root.dataset.excludeProduct, 10) || 0;
    const count = event && event.detail && event.detail.cartCount;
    if (typeof count === 'number' && !ex) {
      render(root, count);
      return;
    }
    fetch(window.theme && window.theme.routes ? window.theme.routes.cart_url + '.js' : '/cart.js')
      .then((r) => r.json())
      .then((cart) => render(root, cart.items.reduce((n, i) => n + (i.product_id === ex ? 0 : i.quantity), 0)))
      .catch((err) => console.warn('rt-volume-ladder: /cart.js falhou', err));
  }

  // só o cart:change: traz o cartCount depois do add. O theme:cart:add dispara no clique, antes do
  // POST, e o /cart.js dele podia chegar depois e repor a contagem antiga.
  document.addEventListener('theme:cart:change', update);
})();
